<template>
  <div>

  <div class="flexc-cen-x fixed">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
       <el-breadcrumb-item>{{nmae1}}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
        <el-option
                  v-for="item in DianList"
                  :key="item.ID"
                  :label="item.StoresName"
                  :value="item.ID">
        </el-option>
      </el-select>
  </div>
  <div class="csss flex-spc-x">
      <el-form :inline="true" :model="formInline" class="flex-cen-x"  style="display:flex;flex-wrap:wrap;padding-top:30px">
        <el-form-item label="搜索：">
          <el-input size="mini" placeholder="请输入姓名/手机号" v-model="selectMembersName"  auto-complete="off"></el-input>
         </el-form-item>
        <el-form-item :label="WZXMName +'：'" prop="objID" v-if=" projectList.length>1 ">
            <el-select clearable v-model="objID"   placeholder="请选择" size="mini">
                  <el-option
                    v-for="item in projectList"
                    :key="item.ID"
                    :label="item.ProjectName"
                    :value="item.ID">
                  </el-option>
                </el-select>
        </el-form-item>

        <el-form-item label="时间:">
            <el-date-picker
              v-model="tdate"
              type="date"
              placeholder="选择日期"
              size="mini"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              style="width:170px"
              >
            </el-date-picker>
                至
            <el-date-picker
              v-model="mdate"
              type="date"
              placeholder="选择日期"
              size="mini"
              style="width:170px"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
              >
            </el-date-picker>
        </el-form-item>

        <el-form-item>
              <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
       <el-button size="mini" style="margin-top:30px"  type="primary" @click="toAdd()" v-if="q1 == true">+ 添加预约</el-button>
  </div>
  
  <el-table :data="tableData" highlight-current-row v-loading="loading" size="mini"   element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
          <el-table-column  prop="yyTime" label="预约时间"  >
          </el-table-column>
          <el-table-column  prop="ProjectName" :label=" WZXMName+'名称' " >
          </el-table-column>
          <el-table-column  prop="Name" label="顾客信息" >
            <template slot-scope="scope">
                <div class="flexc-cen-x">
                <img :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl !='' " style="width:25px;height:25px;border-radius:100%" alt="">
                <img v-if="scope.row.HeadUrl =='' " src="../../assets/img/head.png" style="width:25px;height:25px;border-radius:100%" alt="">
                  <div v-if="scope.row.Name !=''" style="margin-left:5px;font-size:13px">{{scope.row.Name}}</div>
               <div v-else style="margin-left:5px;font-size:13px">{{scope.row.wxName}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="PreAboutCount" label="预约人数" align="center" >
             <!-- <template slot-scope="scope"> 
               <div class="flex-xy" @click="toNumber(scope.row)" v-if="scope.row.state == 1">
                  <div class="flexc-cen-x">
                    <div style="width:30px;color:#409EFF">{{scope.row.PreAboutCount}}</div>
                    <el-button type="text" icon="el-icon-edit"></el-button>
                  </div>
              </div>
             <div class="flex-xy"  v-if="scope.row.state != 1">
                <div style="width:30px;margin-left:-17px">{{scope.row.PreAboutCount}}</div>
                 
              </div>
            </template> -->
          </el-table-column>
          <el-table-column prop="PayAmount" label="在线支付金额" align="center" >
          </el-table-column>
          <el-table-column  prop="Phone" label="联系电话"  align="center">
          </el-table-column>
          <el-table-column  prop="state" label="状态" align="center" width="150">
                  <template slot-scope="scope">
                    <span class="Info" v-if="scope.row.state == 0">
                      学员取消
                    </span>
                    <span class="coBlue" v-if="scope.row.state == 1">
                    已预约
                    </span>
                    <span class="Success" v-if="scope.row.state == 2">
                      已{{typeName}}
                    </span>
                    <span class="Danger" v-if="scope.row.state == 3">
                    未到
                    </span>
                    <span class="Info" v-if="scope.row.state == 4">
                      机构取消
                    </span>
                    <span class="Warning" v-if="scope.row.state == 5">
                    请假
                    </span>
                  </template>
          </el-table-column>
          <el-table-column  prop="terName" label="业务归属人"  align="center">
          </el-table-column>
          <el-table-column align="center" label="操作" width="350" >
            <template slot-scope="scope">
              <el-button  size="mini" type="primary" v-if="q2 == true" @click="handleEdit(scope.row)">详情</el-button>
              <!-- <el-button size="mini" type="success" v-if="(scope.row.state == 2||scope.row.state == 3 || scope.row.state == 5 ) && q3 == true"   @click="chexiao(scope.row)" >撤销</el-button> -->
              <!-- <el-button size="mini" type="success" v-if="scope.row.state != 2 && q3 == true" @click="hexiao(scope.row)" >{{typeName}}</el-button> -->
              <el-button size="mini" type="success" v-if=" q3 == true" @click="hexiaonew(scope.row)" >{{typeName}}</el-button>

              <el-button size="mini" type="warning" v-if="scope.row.state == 1 && q4 == true" @click.native.prevent="todel(scope.row)" >取消预约</el-button>
              <el-button size="mini" type="warning" v-if="scope.row.state != 1 && q4 == true" disabled @click.native.prevent="todel(scope.row)" >取消预约</el-button>
              <el-button size="mini" type="primary" v-if="scope.row.state == 2 " @click="editYeShow(scope.row)">业务归属人</el-button>
              <el-button size="mini" disabled type="primary" v-if="scope.row.state != 2 ">业务归属人</el-button>
            </template>
          </el-table-column>
  </el-table>
 
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!--列表-->

    <!-- 分页组件 -->
    
    <!-- 编辑界面 -->
    <el-drawer :wrapperClosable= false title="详情" :visible.sync="editFormVisible" :direction="direction" size="30%">
      <div class="bottomBORD">
        <div style="margin-left:2%;font-size:15px">服务信息</div>
          <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:30px">
              <div style="color:#7e7e7e;width:80px">状态：</div>
              <div> <span class="Info" v-if="mainList.state == 0">
                    学员取消
                  </span>
                  <span class="coBlue" v-if="mainList.state == 1">
                   已预约
                  </span>
                  <span class="Success" v-if="mainList.state == 2">
                    已{{typeName}}
                  </span>
                  <span class="Danger" v-if="mainList.state == 3">
                   未到
                  </span>
                  <span class="Info" v-if="mainList.state == 4">
                    机构取消
                  </span>
                  <span class="Warning" v-if="mainList.state == 5">
                   请假
                  </span>
              </div>
          </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">{{WZXMName}}名称：</div>
                  <div class="flexc-cen-x">
                    <img :src="mainList.ProjectHeadUrl" style="width:25px;height:25px;border-radius:100%" alt="">
                    <div style="margin-left:5px;font-size:13px">{{mainList.ProjectName}}</div>
                  </div>
            </div>
            <!-- <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">服务人员：</div>
                    <div class="flexc-cen-x">
                      <img :src="mainList.terHeadUrl" v-if="mainList.terHeadUrl!='' " style="width:25px;height:25px;border-radius:100%" alt="">
                      <img v-if="mainList.terHeadUrl =='' " src="../../assets/img/head.png" style="width:25px;height:25px;border-radius:100%" alt="">
                    <div style="margin-left:5px;font-size:13px">{{mainList.terName}}</div>
                  </div>
            </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">场地：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">{{mainList.SiteName}}</div>
                  </div>
            </div> -->
            <!-- <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">项目时间：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">{{mainList.SKtime}} {{mainList.startTimeNew}}</div>
                  </div>
            </div> -->
            
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">{{WZXMName}}时长：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">{{mainList.Timelength}} 分钟</div>
                  </div>
    
            </div>
      </div>
      <div class="bottomBORD" style="margin-top:30px">
        <div style="margin-left:2%;font-size:15px">顾客信息</div>

            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:30px">
                  <div style="color:#7e7e7e;width:80px">姓名：</div>
                    <div class="flexc-cen-x">
                      <img :src="row.HeadUrl" v-if="row.HeadUrl!='' " style="width:25px;height:25px;border-radius:100%" alt="">
                      <img v-if="row.HeadUrl =='' " src="../../assets/img/head.png" style="width:25px;height:25px;border-radius:100%" alt="">
                     <div v-if="row.Name !=''" style="margin-left:5px;font-size:13px">{{row.Name}}</div>
                    <div v-if="row.Name ==''" style="margin-left:5px;font-size:13px">{{row.wxName}}</div>
                  </div>
            </div>
              <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">联系电话：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">{{mainList.Phone}}</div>
                  </div>
    
               
            </div>
              <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">预约人数：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">{{mainList.PreAboutCount}}</div>
                  </div>
    
               
            </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">预约时间：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">{{mainList.yyTime}} {{mainList.yyStime}}</div>
                  </div>
    
               
            </div>
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">预约方式：</div>
                  <div class="flexc-cen-x" v-if="mainList.isZF == 1">
                    <div style="margin-left:5px;font-size:13px">线上支付</div>
                  </div>
                  <div class="flexc-cen-x" v-if="mainList.isZF == 0 && mainList.vipID == 0">
                    <div style="margin-left:5px;font-size:13px">无卡预约</div>
                  </div>
                  <div class="flexc-cen-x" v-if="mainList.isZF == 0 && mainList.vipID != 0">
                    <div style="margin-left:5px;font-size:13px">会员卡支付({{mainList.vipName}})</div>
                  </div>
            </div>
            <div v-if="isyhq==1 && mainList.isZF == 1" class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">优惠券：</div>
                  <div class="flexc-cen-x"  >
                    <div style="margin-left:5px;font-size:13px">{{mainList.yhqTitle}}</div>
                  </div>
            </div>
            
            <div class="flexc-cen-x" v-if="mainList.isZF == 1" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">扣除：</div>
                  <div class="flexc-cen-x" v-if="mainList.isZF == 1">
                    <div style="margin-left:5px;font-size:13px">{{mainList.PayAmount}}元</div>
                  </div>
                  <div class="flexc-cen-x" v-if="mainList.isZF == 0 && mainList.vipID == 0">
                    <div style="margin-left:5px;font-size:13px">无</div>
                  </div>
                  <div class="flexc-cen-x" v-if="mainList.isZF != 1 && !(mainList.isZF == 0 && mainList.vipID == 0)">
                    <div style="margin-left:5px;font-size:13px">{{mainList.vipvule}}</div>
                  </div>
            </div>
            <!-- <div class="flexc-cen-x" v-if="mainList.isZF == 1" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">付款金额：</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">￥{{mainList.PayAmount}}</div>
                  </div>
            </div> -->

      </div>
      <div class="bottomBORD" style="margin-top:30px;margin-bottom:100px" >
        <div style="margin-left:2%;font-size:15px;margin-bottom:30px">预约信息</div>

            <div v-for="(items,index) in mainList.listPreAboutInfo" v-if="items.state !=3" style="margin-bottom:15px;">
            <div class="flexc-cen-x" style="font-size:13px;margin-left:5%;margin-top:10px">
                  <div style="color:#7e7e7e;width:80px">{{items.Title}}:</div>
                  <div class="flexc-cen-x">
                    <div style="margin-left:5px;font-size:13px">{{items.FormsInfo}}</div>
                  </div>
    
               
            </div>
                
           
             
                
                  <!-- <span style="margin-left:5%">名称：{{}}</span> -->
            </div>

      </div>

        <div class="demo-drawer__footer flex-r-x"  style="width:30%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
            style="margin-right:20px"
            size="small"
            type="primary"
            @click="closeDialog"
            >确定</el-button
          >
        </div>
    </el-drawer>

    <el-dialog :title="typeName" :visible.sync="hexiaoShow" width="40%">

      <el-form label-width="120px" >
        <!-- <el-form-item :label="'使用'+name+'码:'" prop="isCode" v-if="mainList.isZF != 1">
          <el-radio-group v-model="isCode">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <!-- <el-form-item :label="name+'码'" prop="number" v-if="isCode == 1">
          <el-input size="small" placeholder="请输码" v-model="code"  auto-complete="off"></el-input>
        </el-form-item> -->
        <el-form-item label="选择会员卡:" v-if="isCode == 0 && isCard == 1">
              <el-select v-model="vipID" placeholder="请选择" size="small" @change="tochoosevip()">
                <el-option
                  v-for="item in cardList"
                  :key="item.ID"
                  :label="item.CardName"
                  :value="item.ID">
                </el-option>
              </el-select>
        </el-form-item>
        <el-form-item :label="name+'方式:'" prop="isCode" v-if="isCode == 0 && isCard == 0">
          <el-radio-group v-model="vipID">
            <el-radio :label="-1">储蓄卡</el-radio>
            <el-radio :label="-2">储次卡</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="金额" prop="number" v-if=" vipID==-1 && isCard == 0">
            <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
            元
        </el-form-item>
        <el-form-item label="次数" prop="number" v-if=" vipID == -2 && isCard == 0" >
            <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
        </el-form-item>
          <el-form-item label="金额" prop="number" v-if="(cardType == 4 || cardType == 5)   && isCard == 1">
            <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
            元
          </el-form-item>
          <el-form-item label="次数" prop="number" v-if="(cardType == 1 || cardType == 2)  && isCard == 1" >
            <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
          </el-form-item>
          <el-form-item label="预约人数:" prop="Note">
              <el-input-number size="small" v-model="mainList.PreAboutCount" :step="1" :min="1"></el-input-number>
        </el-form-item>

            <el-form-item label="选择业务归属人" prop="number" >
            <span>{{mainList.terName}}</span>
            <el-button type="text" style="margin-left:20px" @click="handlePassword1">选择</el-button>
        </el-form-item>
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="sure()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="typeName" :visible.sync="hexiaoShow1" width="40%">

<el-form label-width="120px" >
 
  <el-form-item label="选择会员卡:" v-if="isCode == 0 && isCard == 1">
        <el-select v-model="vipID" placeholder="请选择" size="small" @change="tochoosevip()">
          <el-option
            v-for="item in cardList"
            :key="item.ID"
            :label="item.CardName"
            :value="item.ID">
          </el-option>
        </el-select>
  </el-form-item>
  <el-form-item :label="name+'方式:'" prop="isCode" v-if="isCode == 0 && isCard == 0">
    <el-radio-group v-model="vipID">
      <el-radio :label="-1">储蓄卡</el-radio>
      <el-radio :label="-2">储次卡</el-radio>
    </el-radio-group>
  </el-form-item>
  <el-form-item label="金额" prop="number" v-if=" vipID==-1 && isCard == 0">
      <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
      元
  </el-form-item>
  <el-form-item label="次数" prop="number" v-if=" vipID == -2 && isCard == 0" >
      <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
  </el-form-item>
    <el-form-item label="金额" prop="number" v-if="(cardType == 4 || cardType == 5)   && isCard == 1">
      <el-input size="small" placeholder="请输入金额" v-model="money" type="number"  auto-complete="off" style="width:120px"></el-input>
      元
    </el-form-item>
    <el-form-item label="次数" prop="number" v-if="(cardType == 1 || cardType == 2)  && isCard == 1" >
      <el-input size="small" placeholder="请输入次数" v-model="number"  auto-complete="off" style="width:120px"> </el-input>次
    </el-form-item>
    <el-form-item label="预约人数:" prop="Note">
      <span>1</span>
        <!-- <el-input-number size="small" v-model="mainList.PreAboutCount" :step="1" :min="1"></el-input-number> -->
  </el-form-item>

      <el-form-item label="选择业务归属人" prop="number" >
      <span>{{mainList.terName}}</span>
      <el-button type="text" style="margin-left:20px" @click="handlePassword1">选择</el-button>
  </el-form-item>
  <el-form-item label="备注:" prop="Note">
      <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
  </el-form-item>
</el-form>
<div slot="footer" class="dialog-footer">
  <el-button size="small" @click="closeDialog">取消</el-button>
  <el-button size="small" type="primary" :loading="loading"  @click="sure1()">确定</el-button>
</div>
</el-dialog>
    <el-dialog title="添加预约" :visible.sync="yuyueShow"   width="600px" @click="yuyueShow = false">
        <el-form label-width="100px" :model="editForm" >
          <el-form-item :label="WZXMName+':'" prop="ProjectName">
            <div class="flexc-cen-x" >
              <img :src="showList.HeadUrl" v-if="showList.HeadUrl"  style="width:40px;height:40px;border-radius:100%" alt="">
              <div style="margin-left:10px;font-size:16px;font-weight:600">
                          {{showList.ProjectName}}
              </div>
              <div>
                    <el-button style="margin-left:10px"  type="text"  @click="tochooseObj()">选择</el-button>
              </div>
               
            </div>
          </el-form-item>
          <el-form-item :label="WZXMName+'时长:'" prop="ProjectName" v-if="showList.HeadUrl">
              <div v-if="showList.Timelength">{{showList.Timelength}}分钟</div>
          </el-form-item>
          <el-form-item v-if="showList.isPreAboutInfo == 1 " label="是否选择员工:" prop="isStaff" >
            <el-radio-group v-model="isStaff">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="StaffList.length>0 && isStaff==1" :label="'选择员工：'" prop="" >
              <span>{{StaffName}}</span>
              <el-button style="margin-left:10px" type="text"  @click="toStaffProject">选择</el-button>
            </el-form-item>
           <el-form-item :label="WZHYName+'选择:'" prop="isMembers" >
            <el-radio-group v-model="isMembers">
              <el-radio :label="1">选择{{WZHYName}}</el-radio>
              <el-radio :label="0">非{{WZHYName}}</el-radio>
            </el-radio-group>
          </el-form-item>
            <el-form-item :label="'选择'+WZHYName +':'" prop="" >
              <span>{{vipName}}</span>
              <el-button style="margin-left:10px" type="text"  @click="toVipShow">选择</el-button>
            </el-form-item>
          <el-form-item label="姓名:" prop="Name" v-if="isMembers == 0">
            <el-input size="small" v-model="Name" auto-complete="off" placeholder="请输入姓名"  style="width: 215px"></el-input>
          </el-form-item>
          <el-form-item label="手机号:" prop="Phone" v-if="isMembers == 0">
            <el-input size="small" v-model="Phone" auto-complete="off" placeholder="请输入手机号" style="width: 215px"></el-input>
          </el-form-item>
         
           <el-form-item label="预约人数:">
            <el-input-number size="small" v-model="PreAboutCount"  :min="1" :step="1"  ></el-input-number>
           </el-form-item>
           <div v-if="showList.isPreAboutInfo == 1 " :key="timer" >
            <el-form-item  v-for="(item,index) in ListPreAboutForms" :label="item.Title" :key="index" >
              <div class="flexc-cen-x"  v-if="item.fType == 2">
                  <el-date-picker
                    @input="forceUpdate"
                    v-model="ListPreAboutForms[index].date"
                    style="width:200px"
                    type="date"
                     size="small"
                    placeholder="选择日期"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    @change="doProjectTims(index)">
                  </el-date-picker>
                    <el-select   v-model="ListPreAboutForms[index].time" size="small" style="width:90px;margin-left:5px" filterable  @input="forceUpdate" @change="doProjectyyStime(index)" >
                      <el-option  v-for="item in ListProjectTims" 
                              :value="item.startTime" 
                              :label="item.startTime" 
                              :key="item.startTime">
                            </el-option>
                        </el-select>   
                        <!-- <span style="margin-left:5px;margin-right:5px">:</span>
                    <el-select size="small" v-model="ListPreAboutForms[index].time1" style="width:90px;" filterable  @input="forceUpdate">
                            <el-option v-for="item in coursetminu" :value="item.value" :label="item.label" :key="item.value">
                            </el-option>
                        </el-select>  -->
                <span v-if="item.isbt == 1" style="color:red;margin-left:5px">*</span>

              </div>


                  <el-input style="width:200px"   v-if="item.fType == 1" v-model="ListPreAboutForms[index].info" :key="timer" size="small" placeholder="请输入内容"    @input="forceUpdate"></el-input>
                  <span v-if="item.isbt == 1 && item.fType == 1" style="color:red">*</span>
           </el-form-item>
           </div>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="yuyueShow = false">取消</el-button>
          <el-button size="small" type="primary" :loading="loading" @click="subm()">确定</el-button>
        </div>
    </el-dialog>
    <el-dialog :title="'选择'+WZHYName" :visible.sync="vipShow" >
      <el-form :inline="true" :model="formInline" class="user-search" style="margin-top:-20px">
        <el-form-item label="搜索：">
          <el-input size="small" v-model="selectName" placeholder="输入姓名、手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="searchhui">搜索</el-button>
        </el-form-item>
      </el-form>

      <el-table  :data="vipList" highlight-current-row  max-height="400" style="width: 100%;">

          <el-table-column  prop="Name" label="姓名" align="center" >
            <template slot-scope="scope">
              <div class="flex-xy">
                <img :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl !='' " style="width:50px;height:50px;border-radius:100%" alt="">
                <img v-if="scope.row.HeadUrl =='' " src="../../assets/img/head.png" style="width:50px;height:50px;border-radius:100%" alt="">
                <div style="margin-top:5px;font-size:15px">{{scope.row.Name}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column  prop="Phone" label="手机号"  align="center">
          </el-table-column>
          <el-table-column v-if="isCard==0"  prop="czAmount" label="储蓄金额(元)"  align="center">
          </el-table-column>
          <el-table-column v-if="isCard==0" prop="syNumber" label="次卡次数"  align="center">
          </el-table-column>
        <el-table-column align="center" label="操作" fixed="right" >
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleDetail(scope.row)">选择</el-button>
        
          </template>
        </el-table-column>
      </el-table>

      <Pagination v-bind:child-msg="pageparm1" @callFather="callFather1"></Pagination>
    </el-dialog>

    <el-dialog :title="'选择'+ WZXMName" :visible.sync="ojbshow"  @click="ojbshow = false">
      <el-table  :data="projectList" highlight-current-row  max-height="350" style="width: 100%;">
          <el-table-column  prop="Name" :label="WZXMName+'名称'" align="center" >
            <template slot-scope="scope">
              <div class="flex-xy">
                <img :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl !='' " style="width:50px;height:50px;border-radius:100%" alt="">
                <img v-if="scope.row.HeadUrl =='' " src="../../assets/img/head.png" style="width:50px;height:50px;border-radius:100%" alt="">
                <div style="margin-top:5px;font-size:15px">{{scope.row.ProjectName}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column  prop="ProjectTypeName" label="类型"  align="center">
          </el-table-column>
          <el-table-column  prop="Timelength" label="时长(分钟)"  align="center">
          </el-table-column>
        <el-table-column align="center" label="操作" fixed="right" >
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleObj(scope.row)">选择</el-button>
        
          </template>
        </el-table-column>
      </el-table>

      <Pagination v-bind:child-msg="pageparm3" @callFather="callFather3"></Pagination>
    </el-dialog>
        <el-dialog title="撤销" :visible.sync="cheShow" width="40%">
        <el-form label-width="120px">
          <el-form-item label="撤销原因:" prop="Note">
              <el-input type="textarea" :rows="2" placeholder="请输入原因" v-model="Note" ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cheShow = false">取消</el-button>
          <el-button size="small" type="primary" :loading="loading"  @click="sureChe()">确定</el-button>
        </div>
    </el-dialog>
        <el-dialog title="选择预约人数" :visible.sync="numberShow" width="500px" @click="numberShow= false">
        <el-form label-width="120px">
          <el-form-item label="预约人数:" prop="Note">
              <el-input-number size="small" v-model="mainList.PreAboutCount" :step="1" :min="1"></el-input-number>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="numberShow = false">取消</el-button>
          <el-button size="small" type="primary" :loading="loading"  @click="sureNumber()">确定</el-button>
        </div>

        </el-dialog>
      <el-dialog :title="'选择'+WZYGName" :visible.sync="personShow" width="500px" @click="personShow = false">
        <div class="dialogMain" style="width:100%;height:400px">
            <el-collapse accordion  >
                <el-collapse-item v-for="(items) in personList" :key="items.ID" >
                    <template slot="title">
                            <!-- <img src="../../assets/icon/choose.png" alt="" style="width:18px;height:18px">   -->
                            <span style="margin-left:5px">{{items.Name}}</span>
                    </template>
                    <div class="cursor" v-for="item in items.listsub" :key="item.ID" style="margin-left:20px" @click="choose(item)" >
                        <div class="flex-spc-x" style="margin-top:5px" > 
                            
                            <div style="margin-left:5px;font-size:15px">
                                {{item.Name}}
                            </div>
                            <el-button type="text">选择</el-button>
                        </div> 
                        
                    </div>
                </el-collapse-item>

            </el-collapse>

        </div>
    </el-dialog>
    <el-dialog title="修改业务归属人" :visible.sync="editYe" width="500px" @click="editYe = false">
        <el-form>
        <el-form-item  label="业务归属人：" prop="LoginID">
          <span>{{editRow.terName}}</span>
          <el-button @click="handlePassword1()" style="margin-left:10px" type="text">修改</el-button>     
        </el-form-item>
      </el-form>
       <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editYe = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="sureYe()">修改</el-button>
      </div>
</el-dialog>
<el-dialog
      title="选择员工"
      :visible.sync="StaffProjectshow"
      width="40%"
        >
            <el-table :data="StaffList" ref="tableData" :row-key="(row) => {return row.ID}" :header-cell-style="{'background-color':'#f8f8f8'}" style="width:100%;margin-top:10px;"  >
                  <el-table-column label="员工姓名" prop="Name" ></el-table-column>
                <el-table-column label="手机号" prop="Phone" ></el-table-column>
                <el-table-column align="center" label="操作" fixed="right" >
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleStaff(scope.row)">选择</el-button>
        
          </template>
        </el-table-column>
             </el-table>   
   
          <span slot="footer" class="dialog-footer1">
         <el-button @click="StaffProjectshow = false">取 消</el-button>
        
        </span>
      
    </el-dialog>
    <el-drawer :wrapperClosable= false title="预约列表" :visible.sync="editFormZJHXVisible" :direction="direction" size="50%">

<el-table :data="ListPreAboutZJHX" style="width:100%;margin-top:30px" max-height="480" >
      <el-table-column fixed prop="VerificationCode" label="核销码" align="center" width="220">
      </el-table-column>
      <el-table-column fixed prop="StaffID" label="服务人员" align="center" >
       <template slot-scope="scope"> 
          <span class="Info" v-if="scope.row.StaffID > 0">
            {{scope.row.terName}}
          </span>
      </template>
    </el-table-column>
      <el-table-column fixed prop="vipID" label="会员卡名称" align="center" >
        <template slot-scope="scope"> 
          <span class="Info" v-if="scope.row.vipID > 0 && mainList.isZF==0 ">
            {{scope.row.vipName}}
          </span>
          <span class="Info" v-if="mainList.isZF==1 ">
            线上支付
          </span>
      </template>
      </el-table-column>
      <el-table-column fixed prop="vipID" label="扣除" align="center" >
        <template slot-scope="scope"> 
          <span class="Info" v-if="scope.row.vipID > 0">
            {{scope.row.vipvule}}
          </span>
      </template>
      </el-table-column>
      <el-table-column fixed prop="state" label="状态" align="center" >
          <template slot-scope="scope">
            <span class="Info" v-if="scope.row.state == 0">
              学员取消
            </span>
            <span class="coBlue" v-if="scope.row.state == 1">
             已预约
            </span>
            <span class="Success" v-if="scope.row.state == 2">
              已{{typeName}}
            </span>
            <span class="Danger" v-if="scope.row.state == 3">
             未到
            </span>
            <span class="Info" v-if="scope.row.state == 4">
              机构取消
            </span>
            <span class="Warning" v-if="scope.row.state == 5">
             请假
            </span>
          </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="120">
        <template slot-scope="scope" >
          <el-button size="mini" type="success" v-if="(scope.row.state == 2||scope.row.state == 3 || scope.row.state == 5 ) && q3 == true"   @click="chexiao(scope.row)" >撤销</el-button>
              <el-button size="mini" type="success" v-if="scope.row.state != 2 && q3 == true" @click="hexiao1(scope.row)" >{{typeName}}</el-button>
        </template>
      </el-table-column>
</el-table>

</el-drawer>
  </div>
</template>

<script>
import { deptList, deptSave, deptDelete, roleDropDown } from '../../api/userMG'
import CropperImage from "../../components/CropperImage";
import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      formValidate: {
        mainImage: "",
      },
      numberShow:false,
      date:[],
      code:'',
      coursetime:[{
          value: '00',
          label: '00'
        }, {
          value: '01',
          label: '01'
        }, {
          value: '02',
          label: '02'
        }, {
          value: '03',
          label: '03'
        }, {
          value: '04',
          label: '04'
        }, {
          value: '05',
          label: '05'
        }, {
          value: '06',
          label: '06'
        }, {
          value: '07',
          label: '07'
        }, {
          value: '08',
          label: '08'
        }, {
          value: '09',
          label: '09'
        }, {
          value: '10',
          label: '10'
        }, {
          value: '11',
          label: '11'
        }, {
          value: '12',
          label: '12'
        }, {
          value: '13',
          label: '13'
        }, {
          value: '14',
          label: '14'
        }, {
          value: '15',
          label: '15'
        }, {
          value: '16',
          label: '16'
        }, {
          value: '17',
          label: '17'
        }, {
          value: '18',
          label: '18'
        }, {
          value: '19',
          label: '19'
        }, {
          value: '20',
          label: '20'
        }, {
          value: '21',
          label: '21'
        }, {
          value: '22',
          label: '22'
        }, {
          value: '23',
          label: '23'
        }],
      coursetminu:[{
          value: '00',
          label: '00'
        }, {
          value: '05',
          label: '05'
        }, {
          value: '10',
          label: '10'
        }, {
          value: '15',
          label: '15'
        }, {
          value: '20',
          label: '20'
        }, {
          value: '25',
          label: '25'
        }, {
          value: '30',
          label: '30'
        }, {
          value: '35',
          label: '35'
        }, {
          value: '40',
          label: '40'
        }, {
          value: '45',
          label: '45'
        }, {
          value: '50',
          label: '50'
        }, {
          value: '55',
          label: '55'
        }],
      selectMembersName:"",
         personList:[],
      Note:'',
      vipName:'',
      selectName:'',
      isMembers:1,
      vipShow:false,
      Site:'',
      activeName: 'first',
      value:true,
      direction: "ltr",
      projectList:[],
      passShow:false,
      showList:[],
      ProjectHeadUrl:'',
      input:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      chongShow:false,
      SelectStoresID:localStorage.getItem("StoresID"),
      title: '添加',
      tableData:[],
      Pwd:'',
      objID:'',
      site:'',
      tdate:'',
      mdate:'',
      cheShow:false,
      mainList:[],
      DianList:[],
      hexiaoShow:false,
      hexiaoShow1:false,
      PreAboutZJHXID:'',
      LoginID:-1,
      yuyueShow:false,
      ProjectTypeID:0,
          PreAboutCount:1,
          vipID:'',
    //   SelectStoresID:1,
      editForm: {
        LoginName:"",
        Phone:"",
        Name:"",
        pwd:"",
        money:"",
        ShopName:"",
        token: localStorage.getItem('token')
      },
      ojbshow:false,
      money:1.00,
      // rules表单验证

      rules: {
        LoginName: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
          Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
          Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
          pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
          money: [{ required: true, message: '请输入余额', trigger: 'blur' }],
          ShopName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
      },
            cardList:[],
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      formInline1:{
          page: 1,
        limit: 10,
      },
        isCard:localStorage.getItem("isCard"),
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      MembersID:'',
      typeList:[],
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      vipList:[],
      WZYGName:'',
      WZHYName:'',
      WZXMName:'',
      WZPBName:'',
      cardType:'',
      Phone:'',
      Name:'',
      isCode:0,
      row:'',
      number:1,
      editRow:{},
           editYe:false,
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
       pageparm3: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
       pageparm1: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      Limits:[],
      StaffList:[],
      q1:false,
      q2:false,
      q3:false,
      q4:false,
      q5:false,
      typeName:'',
      StaffName:'',
      StaffID:'',
      yyTime:'',
      yyStime:'',
      isStaff:1,
      StaffProjectshow:false,
      personShow:false,
      ListProjectTims:[],
      ListPreAboutZJHX:[],
      iszjyy:localStorage.getItem('iszjyy'),
      isyhq:localStorage.getItem('isyhq'),
      editFormZJHXVisible: false, //控制编辑页面显示与隐藏
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  mounted() {
    //     setTimeout(() => {
    //         this.ListPreAboutForms[0].info = 'd';
    //         console.log(this.list);
    // }, 1000);
},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
    if(localStorage.getItem('StoresType')== 1){
          this.name = '签到'
          this.nmae1 = localStorage.getItem('zzjy') 
          this.typeName = '签到'
        
      }  else {
          this.typeName = '核销'
          this.name = '核销'
          this.nmae1 = localStorage.getItem('zzjy') 
        
      }     
      if(localStorage.getItem('isAdmin') == 1){
          this.q1 = true
          this.q2 = true
          this.q3 = true
          this.q4 = true
          this.q5 = true
      }
  this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {
          if(items == 32){
            this.q1 = true
          }
          if(items == 33){
            this.q2 = true
          }
          if(items == 34){
            this.q3 = true
          }
          if(items == 35){
            this.q4 = true
          }
          if(items == 36){
            this.q5 = true
          }
   })
           var date = new Date();
          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var day = date.getDate();
          if (month < 10) {
          month = '0' + month;
          }
          if (day < 10) {
          day = '0' + day;
          }
         
        // this.data.[0] = 
      this.tdate = year + '-' + month + '-' + day;
      this.mdate = year + '-' + month + '-' + day;
      this.getList()
      this.getDianList()
      this.getSiteList()
      this.getProjectList()
            this.getType()
            this.getvipList()
      this.getList1()
      // this.ge1tList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    sureYe(){
      var data = { 

          SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          PreAboutID:this.editRow.ID,
          StaffID:this.editRow.LoginID,
        }
        var that = this
        this.ajax('editPreAboutZJStaffID.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "修改成功",duration:2000,
              });
              that.getList()
              that.editYe = false
              //  that.provinceList = res.data
            }

        })
    },
    changedian(){
      this.formInline =  {
          page: 1,
          limit:10,
      },
      this.getList()
      this.getDianList()
      this.getSiteList()
      this.getProjectList()
            this.getType()
            this.getvipList()
      this.getList1()
    },
    editYeShow(row){
      this.editRow = row
      this.editYe = true
    },
      choose(items){
        if(this.editYe == true){

        this.editRow.terName = items.Name
        this.editRow.LoginID =  items.ID
      }
          this.mainList.terName = items.Name
          this.mainList.StaffID = items.ID
          this.personShow = false

      },
    getList1(){

    //  this.tableLoading = true
       var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:100,
          StaffTypeID:''
      }
     
      
      var that = this
      this.ajax('getlistStaffgl.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
          
                that.personList = res.data
          } 

      })
  
  
    },
      handlePassword1(){

        this.personShow = true

    },
        sureNumber(){
       var that = this
   
            var data = { 
              SelectStoresID:this.SelectStoresID,
              StoresID:localStorage.getItem("StoresID"),
              token: localStorage.getItem("token"),
              PreAboutID:this.mainList.ID,
              PreAboutCount:this.mainList.PreAboutCount
            }
         
            this.ajax('editPreAboutCountZJ.aspx',JSON.stringify(data),"POST",function(res){
              if (res.orsuccess == "1") {

                  that.$message({
                    type: "success",
                    message: "修改成功",duration:2000,
                  });
                  that.numberShow = false
                  that.getList()
                 
                }
            })
        // PreAboutCount
    },
    toNumber(row){
      this.mainList =row
      this.numberShow = true
    },
    chexiao(row){
        // this.mainList = row
        this.PreAboutZJHXID =row.ID
        this.cheShow = true
        this.Note = ''
    },
    sureChe(){
      if(this.Note == ''){
         this.$message({ type: "error", message: "请选择原因" ,duration:1000});
         return;
      }
      var that = this
          if(this.mainList.isZF == 1){
            var data = { 
              SelectStoresID:this.SelectStoresID,
              StoresID:localStorage.getItem("StoresID"),
              token: localStorage.getItem("token"),
              PreAboutZJHXID:this.PreAboutZJHXID,
              loginName:localStorage.getItem("Name"),
              loginID:localStorage.getItem("LoginID"),
              Note:this.Note,
            }
         
            this.ajax('RevocationPreAboutPayZJHXTY.aspx',JSON.stringify(data),"POST",function(res){

              if (res.orsuccess == "1") {

                  that.$message({
                    type: "success",
                    message: "撤销成功",duration:2000,
                  });
                  that.cheShow = false
                  that.getListPreAboutZJHX()
                  that.getList()
                 
                }
            })
          
          }  else {
           if(this.isCard == 1){
              var data = { 
                SelectStoresID:this.SelectStoresID,
                StoresID:localStorage.getItem("StoresID"),
                token: localStorage.getItem("token"),
                PreAboutZJHXID:this.PreAboutZJHXID,
                loginName:localStorage.getItem("Name"),
                loginID:localStorage.getItem("LoginID"),
                Note:this.Note,
              }
              this.ajax('RevocationPreAboutZJHXTY.aspx',JSON.stringify(data),"POST",function(res){

                if (res.orsuccess == "1") {

                    that.$message({
                      type: "success",
                      message: "撤销成功",duration:2000,
                    });
                   that.cheShow = false
                   that.getListPreAboutZJHX()
                  that.getList()
                    //  that.provinceList = res.data
                  }
              })
           } else {
               var data = { 
              SelectStoresID:this.SelectStoresID,
              StoresID:localStorage.getItem("StoresID"),
              token: localStorage.getItem("token"),
              PreAboutZJHXID:this.PreAboutZJHXID,
              loginName:localStorage.getItem("Name"),
              loginID:localStorage.getItem("LoginID"),
              Note:this.Note,
            }
         
            this.ajax('RevocationPreAboutZJHXNoCradTY.aspx',JSON.stringify(data),"POST",function(res){

              if (res.orsuccess == "1") {

                  that.$message({
                    type: "success",
                    message: "撤销成功",duration:2000,
                  });
                  that.cheShow = false
                  that.getListPreAboutZJHX()
                  that.getList()
                  //  that.provinceList = res.data
                }
            })
          
           }
        }
    },
    tochoosevip(){
        this.cardList.forEach(items=>{
          if(this.vipID == items.ID){
                  this.cardType = items.CardType
                 
          }
        })
    },
    searchhui(){

      this.formInline1 =  {
          page: 1,
          limit:10,
      },
      this.getvipList()

    },
        forceUpdate () { 
    this.$forceUpdate() 
  },
      print(index){
          this.timer = new Date().getTime()
          console.log(this.timer)
        //  this.$set(this.ListPreAboutForms,"eventAddress",this.ListPreAboutForms[index].info);
      },
      handleObj(rows){
            this.showList = rows
         this.ojbshow = false
         this.StaffID=0;
         this.yyTime ="";
         this.yyStime ="";
         this.StaffName ='';
         this.ListProjectTims =[];
           if(this.showList.isPreAboutInfo == 1){
         this.getPreAboutInfo()
       }
       this.getListStaffProject();

      },
      getListStaffProject(){
    var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          ProjectID:this.showList.ID
        }
        var that = this
        this.ajax('getListStaffProject.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.StaffList = res.data
              
            }

        })
  
},doProjectTims(indexq1){
  if(this.isStaff==1){

    if(this.StaffID== 0 || this.StaffID==''){
      this.ListPreAboutForms[indexq1].date='';
      this.$message({ type: "error", message: "请选择员工" ,duration:1000});
        return; 
    }
  }
  this.yyTime =this.ListPreAboutForms[indexq1].date;
  this.ListPreAboutForms[indexq1].time='';
  this.yyStime='';
  this.ListProjectTims =[];
this.getProjectTims();
},doProjectyyStime(indexq1){
  this.yyStime =this.ListPreAboutForms[indexq1].time;
},
getProjectTims(){
    var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StaffID:this.StaffID,
          yyTime:this.yyTime,
          ProjectID:this.showList.ID,
          isStaff:this.isStaff
          
          
        }
        var that = this
        this.ajax('getProjectTims.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.ListProjectTims = res.data
              
              //  that.provinceList = res.data
            }

        })
  
},
      getPreAboutInfo(){
    var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          objType:'1',
          objID:this.showList.ID
        }
        var that = this
        this.ajax('getListPreAboutForms.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.ListPreAboutForms = res.data
              that.ListPreAboutForms.forEach(items => {
                  items.info = ''
                  items.date = ''
                  items.time = ''
                  items.time1 = ''
              });
              that.timer = new Date().getTime()
              that.preAbout = true
              that.yuyueShow = true
              //  that.provinceList = res.data
            }

        })
  
},
      tochooseObj(){
          this.ojbshow = true
      },toStaffProject(){
        this.StaffProjectshow=true;
      },handleStaff(row){
        this.StaffName =row.Name;
        this.StaffID = row.ID;
        this.StaffProjectshow=false;

      },
          getvipList(){
      var data = { 
        SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline1.page,
          psize:this.formInline1.limit,
          selectName:this.selectName,
      }
    
      
        var that = this
      this.ajax('getListMembersYY.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              
                that.vipList = res.data
               that.pageparm1.total = res.allcount
          } 

      })
  
},
    getListMembersvip(){
         

        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID: this.mainList.MembersID
      }

      var that = this
      this.ajax('getListMembersvip.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
            
                that.cardList =res.data
     
                    var list ={
                        CardName:'无',
                        ID:'0'
                    }
                    that.cardList.push(list)
          } 

      })
     this.vipID =''
    },
    subm(){
      var infoList = []
      console.log(this.ListPreAboutForms)
      if(this.showList.isPreAboutInfo == 1){
       for(var i = 0;i<this.ListPreAboutForms.length;i++){
              if(this.ListPreAboutForms[i].fType != 2){
                var t = {
                      FormsID:this.ListPreAboutForms[i].ID,
                      FormsInfo:this.ListPreAboutForms[i].info
                }
              } else {
                  var t = {
                    FormsID:this.ListPreAboutForms[i].ID,
                    FormsInfo:this.ListPreAboutForms[i].info
                  }
                  if(this.ListPreAboutForms[i].date !=''  ){
                        var t = {
                        FormsID:this.ListPreAboutForms[i].ID,
                        FormsInfo: this.ListPreAboutForms[i].date 

                        // FormsInfo: this.ListPreAboutForms[i].date + ' ' + this.ListPreAboutForms[i].time +':' + this.ListPreAboutForms[i].time1 
                      }
                  } 
               

              }
              console.log(t)


          if(this.ListPreAboutForms[i].isbt == 1){
            if(t.FormsInfo == ''){
                this.$message({ type: "error", message: "请填写表单" ,duration:1000});
                return; 
            }
          } 
          infoList.push(t)
          
      }

      if(this.yyStime ==''){
                 this.$message({ type: "error", message: "请按选择时间" ,duration:1000});
                return; 
      }
    }
    // console.log(infoList)
    if(!this.showList.ID){
        this.$message({ type: "error", message: "请选择项目" ,duration:1000});
       return; 
    }
    if(this.MembersID == '' && this.isMembers == 1){
                   this.$message({ type: "error", message: "请选择会员" ,duration:1000});
                  return;
      }
    if(this.Phone =='' && this.isMembers == 0 && this.Name == ''){
                   this.$message({ type: "error", message: "请输入非会员信息" ,duration:1000});
                  return;
      }
   
        var data = { 

          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          objType:'1',
          MembersID:this.MembersID,
          loginID: localStorage.getItem("LoginID"),
          PreAboutCount:this.PreAboutCount,
          ListPreAboutInfo:JSON.stringify(infoList),
          Note:'',
          Phone:this.Phone,
          Name:this.Name,
          isMembers:this.isMembers,
          objID:this.showList.ID,
          StaffID:this.StaffID,
          yyStime:this.yyStime
    
        }
        var that = this
        this.ajax('addPreAboutZJ.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
                that.$message({
                    type: "success",
                    message: "预约成功",duration:2000,
                  });
                  // that.getList()
                  that.yuyueShow = false
                  that.getList()
              //  that.provinceList = res.data
            }

        })
    

      
    },
    handleDetail(items){        
         if(this.isCard == 1){
       
          this.getListMembersvip()
        } else {
          this.cardList = [
          {
            CardName:'储蓄卡',
            ID:'-1'
          },
          {
            CardName:'次卡',
            ID:'-2'
          }
        ]
        }
        this.vipName = items.Name
        this.MembersID = items.ID
        this.vipShow = false
    },
      getType(){
        var data = { 
            SelectStoresID:this.SelectStoresID,        
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            pages:1,
            psize:100,
      }
      var that = this
      this.ajax('getListProjectType.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.typeList = res.data
                //  loading.close();
          } 
       })
      },
    toAdd(){
      this.PreAboutCount = 1
      this.isMembers = 1
      this.Phone = ''
      this.Name = ''
        this.showList=''
        this.vipName = '',
        this.MembersID = '',
        this.StaffName = '',
        this.StaffID = '',
        this.StaffList =[];

        this.ListProjectTims =[];

        this.yuyueShow = true

    },  
    toVipShow(){
      this.formInline1 =  {
          page: 1,
          limit:10,
      },
      this.selectName=''
      this.getvipList()
      this.vipShow =  true
    },
    sure1(){
      if(this.vipID == '' && this.isCode == 0){
             this.$message({ type: "error", message: "请选择会员卡" ,duration:1000});
                          return; 
        }
      if(this.money == 0  && (this.cardType == 4 || this.cardType == 5 ) && this.isCard == 1 && this.isCode == 0 ){
        this.$message({ type: "error", message: "请输入消耗金额" ,duration:1000});
                          return;
      }
        if(this.number == 0 && this.isCode == 0 &&  (this.cardType == 1 || this.cardType == 2 ) && this.isCard == 1){
        this.$message({ type: "error", message: "请输入消耗次数" ,duration:1000});
                          return;
      }
      
//       if(this.code == '' && this.isCode == 1){
//         this.$message({ type: "error", message: "请输入码" ,duration:1000});
//                           return;
//       }
       this.$confirm('是否确认'+ this.name, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
      var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          PreAboutZJHXID:this.PreAboutZJHXID,
          vipID:this.vipID,
          LoginID:localStorage.getItem("LoginID"),
          Note:this.Note,
          sourceName:localStorage.getItem("Name"),
          ConsumptionOfClass:this.number,
          singlePrice:this.money,
          StaffID:this.mainList.StaffID
        
        }
        var that = this
        this.ajax('editPreAboutZJHXstate.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "操作成功",duration:2000,
              });
              that.hexiaoShow1 = false
              // that.getType()
              that.getListPreAboutZJHX()

              that.getList()
              //  that.provinceList = res.data
            }

        })
                    }).catch(() => {
                            
                    });

    },
    sure(){
        if(this.vipID == '' && this.isCode == 0){
             this.$message({ type: "error", message: "请选择会员卡" ,duration:1000});
                          return; 
        }
      if(this.money == 0  && (this.cardType == 4 || this.cardType == 5 ) && this.isCard == 1 && this.isCode == 0 ){
        this.$message({ type: "error", message: "请输入消耗金额" ,duration:1000});
                          return;
      }
        if(this.number == 0 && this.isCode == 0 &&  (this.cardType == 1 || this.cardType == 2 ) && this.isCard == 1){
        this.$message({ type: "error", message: "请输入消耗次数" ,duration:1000});
                          return;
      }
      
//        if(this.number == 0  && this.vipID != -1 && this.isCode == 0 && this.vipID !=0){
//         this.$message({ type: "error", message: "请输入消耗次数" ,duration:1000});
//                           return;
//       }
      if(this.code == '' && this.isCode == 1){
        this.$message({ type: "error", message: "请输入码" ,duration:1000});
                          return;
      }


 this.$confirm('是否确认'+ this.name, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {
      var data = { 
          SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          PreAboutID:this.mainList.ID,
          vipID:this.vipID,
          loginID:localStorage.getItem("LoginID"),
          Note:this.Note,
          sourceName:localStorage.getItem("Name"),
          isCode:this.isCode,
          VerificationCode:this.code,
          ConsumptionOfClass:this.number,
          singlePrice:this.money,
          PreAboutCount:this.mainList.PreAboutCount,
          StaffID:this.mainList.StaffID
        
        }
        var that = this
        this.ajax('editPreAboutStateZJ.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "操作成功",duration:2000,
              });
              that.hexiaoShow = false
              // that.getType()
              that.getList()
              //  that.provinceList = res.data
            }

        })
                    }).catch(() => {
                            
                    });
                

      
    
    },
    hexiaonew(row){
      this.mainList = row
      this.getListPreAboutZJHX()

    },

    getListPreAboutZJHX(){
 
var data = { 

  SelectStoresID:this.SelectStoresID,
  token: localStorage.getItem("token"),
  StoresID:localStorage.getItem("StoresID"),
  PreAboutZID: this.mainList.ID

}

var that = this
this.ajax('getListPreAboutZJHX.aspx',JSON.stringify(data),"POST",function(res){
  if (res.orsuccess == "1") {
    
        that.ListPreAboutZJHX = res.data;
        that.editFormZJHXVisible =true;
      
     
  } 

})
 },
    hexiao(row){
      this.mainList = row
      this.hexiaoShow = true
      this.code = ''
      this.iscode = 1
      this.money = this.mainList.xhAmount
      this.number = this.mainList.xhnumber
      this.vipID = ''
      this.cardType = ''
        if(this.mainList.isZF == 1){
          this.isCode = 1
      } else {
          this.isCode = 0
      }
      if(this.isCard == 0){
        this.vipID = -1
      }


      if(this.isCard == 1){
        this.vipID = '',
          this.getListMembersvip()
        } 
    },
     hexiao1(row){
      this.PreAboutZJHXID= row.ID
      this.hexiaoShow1 = true
      this.code = ''
      this.iscode = 1
      this.money =0
      this.number = 0
      this.vipID = ''
      this.cardType = ''
        if(this.mainList.isZF == 1){
          this.isCode = 1
      } else {
          this.isCode = 0
      }
      if(this.isCard == 0){
        this.vipID = -1
      }


      if(this.isCard == 1){
        this.vipID = '',
          this.getListMembersvip()
        } 
    },

     getProjectList(){
        var data = { 
            SelectStoresID:this.SelectStoresID,        
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            pages:this.formInline.page,
            psize:this.formInline.limit,
            ProjectTypeID:this.ProjectTypeID
          // StaffTypeID:this.active
      }

      
        var that = this
      this.ajax('getListProjectzjyy.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {

                that.projectList = res.data
                that.pageparm3.total = res.allcount
              
          } 

      })
      },
        getSiteList(){
       var data = { 
        SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:200,

      }
  
        var that = this
      this.ajax('getListSite.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
            
                that.siteList = res.data
      
          } 

      })
    },
     getDianList(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               
            }

      })
    },
    getList(){
      if(this.mdate < this.tdate){
        this.$message({ type: "error", message: "结束时间不得小于开始时间" ,duration:1000});
            return;
      }
      const loading = this.$loading({
            lock: true,
            text: '加载中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          selectMembersName:this.selectMembersName,
          ctime1:this.tdate,
          ctime2:this.mdate,
          objID:this.objID,
          Site:this.Site,
          LoginID:this.LoginID,
          pages:this.formInline.page,
          psize:this.formInline.limit,
      }
        var that = this
        this.ajax('getListPreAboutZJ.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
              that.tableData = res.data
              that.pageparm.total = res.allcount

            }
            loading.close();
      })
    },



    handlePassword(row){
      // this.editForm.ManageLoginID = row.ID
      this.Pwd = ''
      this.passShow = true

    },
    handleChong(row){
      this.editForm.ManageLoginID = row.ID
      this.editForm.money = row.money
      this.chongShow = true
      this.money = ''
    },
    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getList()
    },
    callFather1(parm) {
      this.formInline1.page = parm.currentPage
      this.formInline1.limit = parm.pageSize
      this.getvipList()
    },
    callFather3(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getProjectList()
    },
    // 搜索事件
    
    search() {

      this.getList()
      
    },
    noSearch(){
        this.objID =''
        this.Site = ''
        this.LoginID = -1
        this.selectMembersName = ''
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        if (month < 10) {
          month = '0' + month;
        }
        if (day < 10) {
          day = '0' + day;
        }
          // var nowDate = 
        // this.data.[0] = 
      this.date[0] = year + '-' + month + '-' + day;
      this.date[1] = year + '-' + month + '-' + day;
      this.formInline.page = 1
      this.formInline.limit = 10
      this.pageparm={
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
      this.getList()
    },
    //显示编辑界面
    handleEdit: function(row) {
      this.row = row
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          PreAboutID:row.ID
        
      }
        var that = this
       this.ajax('getPreAboutInfoZJ.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
              that.mainList  = res.data
               that.editFormVisible = true
            }
      })
  
      

    },
    // 编辑、增加页面保存方法
    submitForm(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
            if(this.title == '添加'){
                this.add()
            }else {
                this.edit()
            }
        } else {
          return false
        }
      })
    },



    handlejie(row) {
      if(row.Isdisable == 0){
this.$confirm('确定要禁用吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.jie(row)
        })
        .catch(() => {
          
        })
      } else {
this.$confirm('确定要解禁吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.jie1(row)
        })
        .catch(() => {
          
        })
      }
 
     
    },

    todel(items){
     if(items.isZF == 1){
   this.$confirm("确定要取消预约吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
            var data = { 
              SelectStoresID:this.SelectStoresID,
              StoresID:localStorage.getItem("StoresID"),
              token: localStorage.getItem("token"),
              PreAboutID:items.ID,
              loginID:localStorage.getItem("LoginID"),
      
            }
            var that = this
            this.ajax('editPreAboutStateZJTK.aspx',JSON.stringify(data),"POST",function(res){

              if (res.orsuccess == "1") {
                  that.$message({
                    type: "success",
                    message: "取消成功",duration:2000,
                  });
            
                  that.getList()
              
                  //  that.provinceList = res.data
                }

            })
            })
            .catch(() => {

            });
      

      } else {
   
       this.$confirm("确定要取消预约吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { 
          SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          PreAboutID:items.ID,
          loginID:localStorage.getItem("LoginID"),
          Note:'',
        }
        var that = this
        this.ajax('editPreAboutStateZJQX.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "取消成功",duration:2000,
              });
        
              that.getList()
           
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
      
        });
   
      }
  
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.delete(row)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.hexiaoShow = false,
      this.hexiaoShow1 = false,
      this.passShow = false,
      this.chongShow = false,
      this.editFormVisible = false
    }
  }
}
</script>
<style>
.csss .el-form-item {
    margin-bottom: 5px;
}
</style>
<style scoped>
.bottomBORD{
  padding-bottom: 30px;
  width:100%;
  border-bottom: 1px solid #e9e9e9;
}

.main{
  position: absolute;
}
.content{
    font-size: 12px;
  color: #999;
  line-height: 20px;
}
.titleMain{
    font-size: 14px;
    color: #191919;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.offline___NHq4e {
    position: absolute;
    top: -1px;
    right: -1px;
    padding: 0.5px 4px 0.5px 4px;
    /* width: 64px; */
    /* height: 22px; */
    background: rgba(255, 101, 247, 0.04);
    border-radius: 0 8px 0 8px;
    border: 1px solid rgba(187, 14, 255, 0.2);
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    color: #b336fc;
}
.box{
  position: relative;
    width: calc((100% - 80px)/4);
    padding: 20px;
    box-sizing: border-box;
    display: inline-block;
    margin-right: 16px;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
    height: 130px;
}
@media screen and ( max-width: 1400px ) {
  .box{
    cursor: pointer;
    width: calc((100% - 60px)/3);
  }
}
.box:hover{
  box-shadow: 0 4px 16px 0 rgb(0 0 0 / 16%);
}
.shadow:hover {
    border:1px solid #808080;border-radius:2px
}
.shadow {
    border:1px solid #ffffff;border-radius:2px
}

.xiang{
    padding: 1px 4px  1px 4px;
    background-color: #f7f7f7;
    border:1px solid #bbbbbb;
    border-radius: 3px;
    font-size: 10px;
    color:#bbbbbb;
}
  
/* .el-switch__core::after{
 height: 12px !important;
 width :12px !important;
} */
   
.title{
    margin-top: 10px;
    height: 30px;
    font-size: 13px;
    font-weight: bolder;
    border-radius: 3px;
    border-left: 5px solid #334157;

}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/board/board.vue